import { Facebook, Instagram, WhatsApp } from '@material-ui/icons';
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom'

const Wrapper = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  top: 9.2em;
  padding: .5em;
  z-index: 9999;
  position: fixed;
  @media screen and (max-width: 1300px) {
    top: 10em;
  }
  @media screen and (max-width: 1100px) {
    top: 11em;
  }

  @media screen and (max-width: 1050px) {
    top: auto;
    bottom: 1.5em!important;
    position: fixed;
  }
`;

const WrapperIcons = styled.a`
  background-color: #ee5659;
  margin: .3em;
  border-radius: 50%;
  padding: .5em;
  svg {
    font-size: 1.8em!important;
    color: #fff;
  }
`;

const FloatButtons = () => (
  <Wrapper>
    <WrapperIcons href='https://api.whatsapp.com/send?phone=5214428173500&text=' target='_blank'>
      <WhatsApp />
    </WrapperIcons>
    <WrapperIcons href='https://www.facebook.com/imllaboratorios/' target='_blank'>
      <Facebook />
    </WrapperIcons>
    <WrapperIcons href='https://www.instagram.com/iml_laboratorios/' target='_blank'>
      <Instagram />
    </WrapperIcons>
  </Wrapper>
);

export default FloatButtons;
